<template>
  <div class="exchange-detail detail-padding" ref="appScroll">
    <div class="spaceBetween" style="margin-bottom:0.32rem;align-items:end">
      <div class="spaceLeft">
        <!-- <div class="detail-title-01">
          Total Outstanding:
        </div> -->
        <!-- <div class="detail-title-1">
          <big-number :number="overdraft" />
          <span class="td-word-sm">TCash</span>
        </div> -->
      </div>
      <div class="spaceLeft search-form" v-show="activeName == 'Loan'">
        <el-checkbox-group v-model="searchParams.checkList" @change="checkChange">
          <el-checkbox label="3">Liquidated</el-checkbox>
          <el-checkbox label="2">Warning</el-checkbox>
        </el-checkbox-group>

        <search-select @valChange="valChange($event, 'type')" label="Repayment status" :options="typeOptions" />

        <search-date @dateChange="dueDateChange($event, 'dueDate')" label="Due Date" style="margin-left: 0.2rem;" />

        <div class="sapceLeft search-item">
          <el-input v-model="searchParams.loanId" placeholder="No..." suffix-icon="el-icon-search" @change="getList" />
        </div>
      </div>
      <div class="spaceLeft search-form" v-show="activeName == 'Payment'">
        <div class="sapceLeft search-item">
          <el-input v-model="repaySearchParams.loanId" placeholder="No..." suffix-icon="el-icon-search" @change="handleRepaySearch" />
        </div>
        <search-date @dateChange="repayDateChange($event, 'repayTime')" label="Repayment time" style="margin-left: 0.2rem;" />
      </div>
    </div>

    <div class="common-card is-border">
      <div class="common-card-main">
        <div class="exchange-tab-box">
          <el-tabs v-model="activeName">
            <el-tab-pane name="Loan">
              <span slot="label" class="spaceLeft">
                <img src="@/assets/image/loan/title-icon.svg" alt="" style="margin-right: 0.05rem;width:0.21rem;"
                  v-if="activeName === 'Loan'" />
                <img src="@/assets/image/loan/lh-icon.svg" alt="" style="margin-right: 0.05rem;width:0.2rem;" v-else />
                Borrow History
              </span>
            </el-tab-pane>
            <el-tab-pane name="Payment">
              <span slot="label" class="spaceLeft">
                <img src="@/assets/image/loan/rh-active-icon.svg" alt="" style="margin-right: 0.05rem;width:0.2rem;"
                  v-if="activeName === 'Payment'" />
                <img src="@/assets/image/loan/rh-icon.svg" alt="" style="margin-right: 0.05rem;width:0.2rem;" v-else />
                Repay History
              </span>
            </el-tab-pane>
          </el-tabs>
          <div class="right-text-box">
            <!-- <span>
              <i class="iconfont trn-yujing" />
              Low Collatoral Warning Threshold:
              <span class="per-text">{{ LoanPledgeRateWarningValue / 100 }}%</span>
            </span>
            <span>
              <i class="iconfont trn-qingsuan" />
              Liquidation Threshold:
              <span class="per-text">{{ LoanLiquidationRate / 100 }}%</span>
            </span> -->
          </div>
        </div>
        <div style="padding:0.3rem 0.4rem;" v-if="activeName == 'Loan'">
          <div class="table-container">
            <el-table class="common-table" :data="tableList" v-loading="loading" style="width:100%;min-width:1200px;" :fit="false">
              <el-table-column prop="loanId" label="Borrow No." align="center" width="90" :show-overflow-tooltip="true">
                <template slot-scope="{ row }">
                  <div class="spaceRight">
                    <i style="font-size:0.24rem;" v-if="row.status == 2" class="iconfont trn-yujing status-icon is-yujing" 
                       el-tooltip
                       effect="dark"
                       content="The collateral Value is below the Low Collatoral Warning Threshold and needs to be replenished."
                       placement="top" />
                    <i style="font-size:0.24rem;" v-if="row.status == 3" class="iconfont trn-qingsuan status-icon is-qingsuan"
                       el-tooltip
                       effect="dark"
                       content="The collateral value is below the Liquidation Threshold and has been liquidated."
                       placement="top" /> 
                    {{ row.loanId }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="startTime" label="Date" align="left" width="110">
                <template slot-scope="{ row }">
                  {{ moment(row.startTime * 1000).format("YYYY.MM.DD") }}
                </template>
              </el-table-column>
              <el-table-column prop="loanAmount" label="Borrow TCash" align="right" width="140">
                <template slot-scope="{ row }">
                  <big-number :number="row.original.loanAmount" />
                  <span class="td-word-sm">TCash</span>
                </template>
              </el-table-column>
              <el-table-column prop="unitAmount" label="Collateral" align="right" width="140">
                <template slot-scope="{ row }">
                  <big-number :number="row.unitAmount" />
                  <span class="td-word-sm">UNIT</span>
                </template>
              </el-table-column>
              <el-table-column prop="totalDebt" label="Outstanding" align="right" width="150">
                <template slot-scope="{ row }">
                  <big-number :number="row.loanAmount" />
                  <span class="td-word-sm">TCash</span>
                </template>
              </el-table-column>
              <el-table-column prop="dueDate" label="Due Date" align="left" width="120">
                <template slot-scope="{ row }">
                  {{ calculateDueDate(row.original.startTime) }}
                </template>
              </el-table-column>
              <el-table-column prop="status" width="130" label="Repayment Status" align="center">
                <template slot-scope="{ row }">
                  <div class="spaceCenter">
                    <img :src="getRepaymentStatusImg(row)" alt="" style="width:0.24rem" />
                    <span style="margin-left:0.1rem;">{{
                      getRepaymentStatusText(row)
                    }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="Operation" width="200" label="" align="left"  >
                <template slot-scope="{ row }">
                  <div style="display: flex;justify-content: flex-end;overflow: auto;padding-bottom: 0.1rem;">
                    <el-button class="o-btn" @click="toDetail(row)">
                      <span>Details</span>
                    </el-button>
                    <el-button class="o-btn" @click="toRepay(row)" v-if="row.status == 0 || row.status == 2">
                      <span>Repay</span>
                    </el-button>

                    <!--  <el-button class="o-btn" @click="toAddCollate(row)" v-if="isWarningStatus(row)"> -->
                    <el-button  v-if="row.status == 2" class="o-btn" @click="toAddCollate(row)">
                      <span>Add collateral</span>
                    </el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <pagination :total.sync="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
              @pagination="getList()" />
          </div>
        </div>

        <div style="padding:0.3rem 0.4rem;" v-if="activeName == 'Payment'">
          <repayPaymentList ref="repayPaymentList" :searchParams="repaySearchParams" />
        </div>
      </div>
    </div>
    <Repayment ref="Repayment" @refresh="repaySuccess" />
    <addCollate ref="addCollate" @refresh="refresh" />
    <repaySuccessDialog ref="repaySuccessDialog" @success="refresh" />
  </div>
</template>

<script>
import { loanList } from "@/api/ustn/loan.js";
import Repayment from "./repayDialog.vue";
import addCollate from "./addCollateDialog.vue";
import repaySuccessDialog from "./repaySuccessDialog.vue";
import repayPaymentList from "./repayPayment.vue";
import { overdraft } from "@/api/ustn/profile.js";
import { toBigItem } from "@/utils/bigNumberTran.js";
export default {
  components: { Repayment, addCollate, repaySuccessDialog, repayPaymentList },
  data() {
    return {
      loading: false,
      activeName: "Loan",
      searchParams: {
        checkList: [],
        number: undefined,
        type: undefined,
        dueDateStart: undefined,
        dueDateEnd: undefined
      },
      repaySearchParams: {
        loanId: undefined,
        startTime: undefined,
        endTime: undefined
      },
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [
        // {
        //   number: 1,
        //   status: 1,
        //   timestamp: +new Date(),
        //   ustn: 136575475674354353435,
        //   unitAmount: 2342424098976587467,
        //   totalDebt: 456458345634546456
        // },
        // {
        //   number: 1,
        //   status: 2,
        //   timestamp: +new Date(),
        //   ustn: 136575475674354353435,
        //   unitAmount: 2342424098976587467,
        //   totalDebt: 456458345634546456
        // }
      ],
      typeOptions: [
        { value: "Repaid", label: "Repaid" },
        { value: "Unrepaid", label: "Unrepaid" }
      ],
      LoanPledgeRateWarningValue: 0,
      LoanLiquidationRate: 0,
      overdraft: 0,
      dueSoonOnly: false, // 是否只显示即将到期的贷款
    };
  },
  computed: {},
  methods: {
    repayDateChange(val, type) {
      if (val) {
        this.repaySearchParams.startTime = val[0];
        this.repaySearchParams.endTime = val[1]; 
      } else {
        this.repaySearchParams.startTime = undefined;
        this.repaySearchParams.endTime = undefined;
      }
      this.handleRepaySearch();
    },
    handleRepaySearch() {
      if (this.$refs.repayPaymentList) {
        this.$refs.repayPaymentList.searchParams = {
          ...this.repaySearchParams
        };
        this.$refs.repayPaymentList.getList();
      }
    },
    valChange(data, prop) {
      this.searchParams[prop] = data.value;
      if (data.value) {
        this.searchParams.checkList = [];
        // 清空 Due Date 筛选
        this.searchParams.dueDateStart = undefined;
        this.searchParams.dueDateEnd = undefined;
      }
      this.getList();
    },
    checkChange() {
      if (this.searchParams.checkList.length > 0) {
        this.searchParams.type = undefined;
        // 清空 Due Date 筛选
        this.searchParams.dueDateStart = undefined;
        this.searchParams.dueDateEnd = undefined;
      }
      this.getList();
    },
    async init() {
      this.contractParameterInfo = this.$store.getters.contractMap[
        "contractParameterInfo"
      ].contract;
      this.contractTCash = this.$store.getters.contractMap[
        "contractTCash"
      ].contract;
      this.getLoanPledgeRateWarningValue();
      this.getLoanLiquidationRate();
    },
    async getLoanPledgeRateWarningValue() {
      try {
        this.LoanPledgeRateWarningValue = await this.contractParameterInfo.methods[
          "getUSTNLoanPledgeRateWarningValue"
        ]().call({
          from: this.$store.getters.metaMaskObj.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getLoanLiquidationRate() {
      try {
        this.LoanLiquidationRate = await this.contractParameterInfo.methods[
          "getUSTNLoanLiquidationRate"
        ]().call({
          from: this.$store.getters.metaMaskObj.account
        });
      } catch (e) {
        console.log(e);
      }
    },
    async getList(clearDueSoonOnly = false) {
      this.getoverdraft();
      // console.log('this.activeName', this.activeName);
      this.loading = true;
      let status = [],
        totalDebt;
      if (this.searchParams.type == "Repaid") {
        (status = [1]), (totalDebt = 0);
      } else if (this.searchParams.type == "Unrepaid") {
        status = [0, 2, 3];
      }
      
      // 检查URL参数是否需要筛选即将到期的贷款
      this.dueSoonOnly = this.$route.query.dueSoon === 'true' && !clearDueSoonOnly;
      
      try {
        console.log('this.dueSoonOnly', this.dueSoonOnly);
        // 计算日期范围
        const dateTo = this.moment().valueOf();
        const dateFrom = this.moment().subtract(1, 'year').valueOf();
        
        const res = await loanList({
          account: this.$store.getters.metaMaskObj.account,
          page: this.queryParams.page,
          pageSize: this.queryParams.pageSize,
          sortField: "timestamp",
          sequence: "DESC",
          status: this.searchParams.checkList.length
            ? this.searchParams.checkList
            : status,
          totalDebt: totalDebt,
          loanId: this.searchParams.loanId,
          dateFrom: dateFrom,
          dateTo: dateTo,
          dueDateStart: this.searchParams.dueDateStart,
          dueDateEnd: this.searchParams.dueDateEnd
        });
        
        console.log(res);
        
        let loanListResult = res.result ? res.result.list || [] : [];
        
        // 如果需要筛选即将到期的贷款
        if (this.dueSoonOnly) {
          // 获取当前时间和30天后的时间戳
          const now = Date.now();
          const thirtyDaysLater = this.moment().add(30, 'days').valueOf();
          
          // 筛选30天内到期的贷款
          loanListResult = loanListResult.filter(loan => {
            // 贷款开始时间加一年就是到期时间
            const loanDate = new Date(loan.createdAt);
            const dueDate = new Date(loanDate);
            dueDate.setFullYear(dueDate.getFullYear() + 1);
            
            // 如果到期日期在当前时间和未来30天之内，则为即将到期
            const dueDateTimestamp = dueDate.getTime();
            return dueDateTimestamp > now && dueDateTimestamp <= thirtyDaysLater;
          });
        }
        
        this.tableList = loanListResult;
        this.queryParams.total = this.dueSoonOnly ? loanListResult.length : (res.result.total || 0);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    isRepaid(data) {
      // 完全还清，剩余贷款金额为0
      return Number(data.loanAmount) === 0;
    },
    isPartiallyRepaid(data) {
      // 部分还清，剩余贷款金额小于原始贷款金额但大于0
      return Number(data.loanAmount) > 0 && Number(data.loanAmount) < Number(data.original.loanAmount);
    },
    isUnrepaid(data) {
      console.log('isUnrepaid', data);
      // 未还款，剩余贷款金额等于原始贷款金额
      return Number(data.loanAmount - data.interest) === Number(data.original.loanAmount - data.original.interest);
    },
    isWarningStatus(data) {
      // status为2表示预警中
      return data.status === 2;
    },
    isLiquidationStatus(data) {
      // status为3表示清算中
      return data.status === 3;
    },
    getRepaymentStatusText(data) {
      // 根据贷款金额比较判断状态
      if (this.isRepaid(data)) {
        return "Repaid";
      } else if (this.isPartiallyRepaid(data)) {
        return "Partially Repaid";
      } else {
        return "Unpaid";
      }
    },
    //    <img src="@/assets/image/loan/unrepaidIcon.png" alt="" style="width:0.24rem" v-if="isUnrepaid(row)" />
    // <img src="@/assets/image/loan/partiallyRepaidIcon.png" alt="" style="width:0.24rem" v-if="isPartiallyRepaid(row)" />
    //                 <img src="@/assets/image/loan/repaidIcon.png" alt="" style="width:0.2rem;" v-if="isRepaid(row)" />
    getRepaymentStatusImg(data) {
      if (this.isRepaid(data)) {
        return require('@/assets/image/loan/repaidIcon.png');
      } else if (this.isPartiallyRepaid(data)) {
        return require('@/assets/image/loan/partiallyRepaidIcon.png');
      } else {
        return require('@/assets/image/loan/unrepaidIcon.png');
      }
    },
    toRepay(data) {
      this.$refs.Repayment.open({
        row: data
      });
    },
    toAddCollate(data) {
      this.$refs.addCollate.open({
        row: {
          ...data,
          LoanPledgeRateWarningValue: this.LoanPledgeRateWarningValue
        }
      });
    },
    toDetail(row) {
      this.$router.push({
        path: "/TCashFinance/lending/detail",
        // query: {
        //   ...row
        // }
        query: {
          loanId: row.loanId
        }
      });
    },
    getoverdraft() {
      overdraft({
        account: this.$store.getters.metaMaskObj.account
      }).then(res => {
        this.overdraft = res.result || 0;
      });
    },
    refresh() {
      this.getList(true);
      if (this.$refs.repayPaymentList) {
        this.$refs.repayPaymentList.refresh();
      }
    },
    repaySuccess(data) {
      this.$refs.repaySuccessDialog.open({
        data
      });
    },
    calculateDueDate(startTime) {
      if (!startTime) return '-';
      // 计算一年后的到期日期
      console.log('startTime', startTime);
      // 将秒级时间戳转换为毫秒级
      const startDate = new Date(Number(startTime) * 1000);
      const dueDate = new Date(startDate);
      dueDate.setFullYear(startDate.getFullYear() + 1); // 准确增加一年
      return this.moment.utc(dueDate).format("YYYY.MM.DD");
    },
    dueDateChange(val, type) {
      if (val && val[0] && val[1]) {
        console.log('val', val);
        // 由于贷款是一年后到期，需要将用户选择的到期日期增加一年传给后端
        // 这样后端可以根据开始时间进行筛选
        const startDate = this.moment(val[0]).subtract(1, 'year').valueOf();
        const endDate = this.moment(val[1]).subtract(1, 'year').valueOf();
        
        this.searchParams.dueDateStart = startDate;
        this.searchParams.dueDateEnd = endDate; 
      } else {
        this.searchParams.dueDateStart = undefined;
        this.searchParams.dueDateEnd = undefined;
      }
      this.getList();
    },
  },
  created() {
    this.init();
    this.getList(true);
    
    // 如果URL有dueSoon参数，切换到Loan标签页
    if (this.$route.query.dueSoon === 'true') {
      this.activeName = 'Loan';
    }
  }
};
</script>
<style scoped lang="scss">
.detail-padding {
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 1.9rem;
}

// .common-table {
//   ::v-deep  &.el-table {
//     font-size: 0.16rem;
//     background-color: #f5f5f5;
//     .el-table__header-wrapper th {
//       background-color: #f5f5f5;
//       color: #aaaaaa;
//       height: 0.4rem;
//       font-size: 0.16rem;
//       font-weight: normal;
//       word-break: keep-all;
//     }
//     th.is-leaf,
//     td {
//       border-bottom: none;
//       background-color: #f5f5f5;
//     }
//     td {
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #1f1f1f;
//       line-height: 0.24rem;
//     }
//     &::before {
//       background: none;
//     }
//   }
// }

.common-card.is-border .common-card-main {
  padding: 0.26rem 0;
  // min-height: 60vh;

  >>>.el-tabs__active-bar {
    background: linear-gradient(269deg, #225bfc 0%, #0e3491 100%);
  }

  >>>.el-tabs .el-tabs__nav .el-tabs__item.is-active {
    color: #fff;
    font-size: 0.22rem;
    font-weight: bold;
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  display: block;
}

.exchange-tab-box {
  border-bottom: 0.02rem solid rgba(146, 157, 173, 0.2);
  padding: 0;
  position: relative;
}

.exchange-tab-body {
  padding: 0.38rem 0.4rem 0 0.4rem;
}

::v-deep  .el-tabs {
  .el-tabs__header {
    margin-bottom: 0;
  }

  .el-tabs__nav {
    width: 100%;

    .el-tabs__item {
      font-size: 0.22rem;
      color: rgba(255, 255, 255, 0.5);
      padding: 0 0.4rem 0.26rem 0.4rem;
      height: auto;
      text-align: center;

      &.is-active {
        color: #34dac5;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
      }
    }
  }

  .el-tabs__nav-wrap::after {
    height: 0;
  }
}

.search-form {
  justify-content: end;

  >>>.el-input__inner {
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  >>>.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #dce0e7;
  }

  >>>.el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #325df3;
    background-color: #325df3;
  }
}

.right-text-box {
  position: absolute;
  right: 0.4rem;
  top: 0.2rem;
  color: #dce0e7;
  font-size: 0.2rem;

  &>span {
    margin-left: 0.4rem;
  }

  .per-text {
    color: #38f4ba;
    font-weight: 500;
  }
}

.status-icon {
  color: #aaaaaa;
  margin-right: 0.12rem;
  font-size: 0.24rem;
  width: 0.24rem;
  height: auto;
  
  &.is-yujing {
    color: #ff9800;
  }

  &.is-qingsuan {
    color: #d71718;
  }
}

.detail-title-01 {
  font-size: 0.2rem;
  font-weight: 500;
  margin-right: 0.08rem;
  color: rgba(255, 255, 255, 0.7);
}

.detail-title-1 {
  .big-number {
    color: #fff;
    font-size: 0.28rem;
  }
}

.common-table {
  >>>.el-loading-mask {
    background-color: rgba(0, 0, 0, 0.6);
  }

  >>>.el-loading-spinner .path {
    stroke: #2675f1;
  }

  >>>.el-table {
    width: auto !important;
    min-width: 1200px;
  }
  
  >>>.el-table__body-wrapper {
    overflow-x: visible;
  }
  
  >>>.el-table__header-wrapper {
    overflow-x: visible;
  }
  
  >>>.el-table__body {
    min-width: 1200px;
  }
  
  >>>.el-table__header {
    min-width: 1200px;
  }
  
  >>>.el-table .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .o-btn {
    padding: 0.11rem 0.2rem;
    border-radius: 0.06rem;
    font-size: 0.15rem;
    background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
    cursor: pointer;
    color: #ffffff;
    border: 0;
  }
}
</style>
